import React, { useState } from 'react';
import MenuzenLogo from '@menuzen/icon/build/solid/Menuzen';
import ThreeDotIcon from '@menuzen/icon/build/outline/ThreeDot';
import Share from '@menuzen/icon/build/outline/Share';
import StyledComponent, { ResponsiveStyle } from '../../core/StyledComponent';
import ToSModal from './ToSModal';
import ShareButton from './ShareButton';
import { Account, DesignMode, DesignSettings, useNode } from '@mnz/builder';
import { px2rem } from '../../core';
import { useTheme } from '@mui/material';

interface FooterProps extends ResponsiveStyle {
    mnzSiteUrl?: string;
    isLiveMode: boolean;
    designSettings: DesignSettings;
    account: Account;
}

const BaseFooter: React.FC<FooterProps> = ({
    designSettings,
    mnzSiteUrl = 'https://www.menuzen.site/',
    account,
    isLiveMode,
}) => {
    const theme = useTheme();
    const {
        query: { getOptions },
    } = useNode();
    const disabled = getOptions().enabled;
    const [openToSModal, setOpenToSModal] = useState(false);
    const handleClickMoreOption = () => {
        if (isLiveMode) {
            setOpenToSModal(true);
        }
    };
    if (disabled) {
        return null;
    }
    return (
        <>
            <StyledComponent
                xs={{
                    marginTop: 30,
                    marginBottom: 30,
                    height: 35,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: theme.typography.fontFamily,
                    color: theme.palette.primary.main,
                }}
            >
                {account.webSetting.showDefaultBranding && (
                    <StyledComponent
                        xs={{
                            height: '100%',
                            borderRadius: 5,
                            marginRight: 15,
                            paddingLeft: 15,
                            paddingRight: 15,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#F4F4F4',
                        }}
                    >
                        <StyledComponent xs={{ fontSize: 18 }}>
                            <MenuzenLogo />
                        </StyledComponent>
                        {isLiveMode ? (
                            <StyledComponent
                                as={'a'}
                                href={mnzSiteUrl}
                                target="_blank"
                                rel="noreferrer"
                                xs={{
                                    fontSize: 12,
                                    lineHeight: '15px',
                                    fontWeight: 700,
                                    marginLeft: 10,
                                }}
                            >
                                menuzen.site
                            </StyledComponent>
                        ) : (
                            <StyledComponent
                                className="text-12 leading-15 font-bold ml-3"
                                xs={{
                                    fontSize: 12,
                                    lineHeight: '15px',
                                    fontWeight: 700,
                                    marginLeft: 3,
                                }}
                            >
                                menuzen.site
                            </StyledComponent>
                        )}
                    </StyledComponent>
                )}
                {getOptions().mode === DesignMode.LIVE && (
                    <ShareButton
                        isLiveMode={isLiveMode}
                        designSettings={designSettings}
                        xs={{
                            height: '100%',
                        }}
                    >
                        <StyledComponent
                            xs={{
                                height: '100%',
                                borderRadius: 5,
                                marginRight: 15,
                                paddingLeft: 15,
                                paddingRight: 15,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#F4F4F4',
                            }}
                        >
                            <Share />
                            <StyledComponent xs={{ fontSize: px2rem(12), fontWeight: 600, marginLeft: px2rem(4) }}>
                                Share
                            </StyledComponent>
                        </StyledComponent>
                    </ShareButton>
                )}
                <StyledComponent
                    onClick={handleClickMoreOption}
                    xs={{
                        cursor: 'pointer',
                        height: '100%',
                        width: 35,
                        borderRadius: 5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#F4F4F4',
                    }}
                >
                    <ThreeDotIcon />
                </StyledComponent>
                <ToSModal title={''} open={openToSModal} onClose={() => setOpenToSModal(false)} />
            </StyledComponent>
        </>
    );
};

export default BaseFooter;
